import React from "react";

const CodigoIcon = ({ width = 32, height = 32 }) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_9001_8417" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
      <rect width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_9001_8417)">
      <path d="M3.40323 22V13H0.5V10H6.30645V22H3.40323ZM10.1774 22V17C10.1774 16.4333 10.3629 15.9583 10.7339 15.575C11.1048 15.1917 11.5645 15 12.1129 15H15.9839V13H10.1774V10H16.9516C17.5 10 17.9597 10.1917 18.3306 10.575C18.7016 10.9583 18.8871 11.4333 18.8871 12V15C18.8871 15.5667 18.7016 16.0417 18.3306 16.425C17.9597 16.8083 17.5 17 16.9516 17H13.0806V19H18.8871V22H10.1774ZM21.7903 22V19H27.5968V17H23.7258V15H27.5968V13H21.7903V10H28.5645C29.1129 10 29.5726 10.1917 29.9435 10.575C30.3145 10.9583 30.5 11.4333 30.5 12V20C30.5 20.5667 30.3145 21.0417 29.9435 21.425C29.5726 21.8083 29.1129 22 28.5645 22H21.7903Z" fill="#E70017" />
    </g>
  </svg>
);

export default CodigoIcon;
